export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/makers_experience_perseus/apps/Illustration-value-6.6ed6b39.svg";